let Class = require('sma.fs/chide/class');
let chide = require('sma.fs/chide/ui');
let Option = require('sma.fs/surveys/options').Option;

$.cloneObj = $.cloneObject = function(obj){
	const clone = ((obj.constructor.toString().indexOf('Array') != -1) ? [] : {});
	for (let property in obj) {
		if (obj[property] && typeof obj[property] == 'object') {
			clone[property] = $.cloneObject(obj[property]);
		} else {
			clone[property] = obj[property];
		}
	}
	return clone;
};

const Validation = $.klass(Option.Value, {
	label: gettext('Validation'),
	displayInline: true,

	validationTypes: [{
		type: 'email',
		label: gettext('Email'),
		showRange: false,
		showValueRange: false,
		showPrecision: false,
		showDomain: true,
		regex: '^.*$',
		errorMsg: {
			en: 'Invalid Email address.',
			fr: 'Adresse de courriel invalide.',
			trans: gettext('Invalid Email address.')
		}
	}, {
		type: 'num',
		label: gettext('Integers (Positive)'),
		showRange: true,
		showValueRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^[0-9]*$',
		errorMsg: {
			en: 'This field can only consist of positive numbers.',
			fr: 'Ce champ ne peut contenir que des nombres positifs.',
			trans: gettext('This field can only consist of positive numbers.')
		}
	}, {
		type: 'pos-neg-num',
		label: gettext('Integers (Positive & Negative)'),
		showRange: true,
		showValueRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^-?[0-9]*$',
		errorMsg: {
			en: 'This field can only consist of numbers.',
			fr: 'Ce champ ne peut contenir que des nombres.',
			trans: gettext('This field can only consist of numbers.')
		}
	},{
		type: 'float',
		label: gettext('Floating Point'),
		showRange: true,
		showPrecision: true,
		showDomain: false,
		regex: '^-{0,1}[0-9]*((\\.|,)?[0-9]+)?$',
		errorMsg: {
			en: 'This field can only consist of numbers and decimals.',
			fr: 'Ce champ ne peut contenir que des nombres et des décimales.',
			trans: gettext('This field can only consist of numbers and decimals.')
		}
	}, {
		type: 'alpha',
		label: gettext('Letters'),
		showRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^[À-ÿA-Za-z \\r\\n]*$',
		errorMsg: {
			en: 'This field can only consist of letters.',
			fr: 'Ce champ ne peut contenir que des lettres.',
			trans: gettext('This field can only consist of letters.')
		}
	}, {
		type: 'alphanum',
		label: gettext('Letters and Numbers'),
		showRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^[À-ÿA-Za-z0-9 \\r\\n]*$',
		errorMsg: {
			en: 'This field can only consist of letters or numbers.',
			fr: 'Ce champ ne peut contenir que des lettres ou des nombres.',
			trans: gettext('This field can only consist of letters or numbers.')
		}
	}, {
		type: 'date-year',
		label: gettext('Date (YYYY/MM/DD)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^\\d{4}\\\/(0?[1-9]|1[012])\\\/(0?[1-9]|[12][0-9]|3[01])$',
		errorMsg: {
			en: 'This field can only be a date in the form YYYY/MM/DD.',
			fr: 'Ce champ doit contenir une date en forme AAAA/MM/JJ',
			trans: gettext('This field can only be a date in the form YYYY/MM/DD.')
		}
	}, {
		type: 'date-day',
		label: gettext('Date (DD/MM/YYYY)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^(0?[1-9]|[12][0-9]|3[01])\\\/(0?[1-9]|1[012])\\\/\\d{4}$',
		errorMsg: {
			en: 'This field can only be a date in the form DD/MM/YYYY.',
			fr: 'Ce champ doit contenir une date en forme JJ/MM/AAAA',
			trans: gettext('This field can only be a date in the form DD/MM/YYYY.')
		}
	}, {
		type: 'date-month',
		label: gettext('Date (MM/DD/YYYY)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^(0?[1-9]|1[012])\\\/(0?[1-9]|[12][0-9]|3[01])\\\/\\d{4}$',
		errorMsg: {
			en: 'This field can only be a date in the form MM/DD/YYYY.',
			fr: 'Ce champ doit contenir une date en forme MM/JJ/AAAA',
			trans: gettext('This field can only be a date in the form MM/DD/YYYY.')
		}
	}, {
		type: 'phoneint',
		label: gettext('Phone Number: International'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[+]*[0-9 \\-().]*$',
		errorMsg: {
			en: 'This field can only be a valid phone number.',
			fr: 'Ce champ ne peut contenir qu’un numéro de téléphone valide.',
			trans: gettext('This field can only be a valid phone number.')
		}
	}, {
		type: 'phone10',
		label: gettext('Phone Number: 10 digit'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[0-9]{3}-[0-9]{3}-[0-9]{4}$',
		errorMsg: {
			en: 'This field must be a 10 digit phone number in ###-###-#### format.',
			fr: 'Ce champ doit être un numéro de téléphone comprenant 10 caractères numériques dont le format est ###-###-####.',
			trans: gettext('This field must be a 10 digit phone number in ###-###-#### format.')
		}
	}, {
		type: 'phoneint-ext',
		label: gettext('Phone Number: International (Allow Extension)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^\\+?[0-9]{1,3}[0-9 \\-().]+?[0-9]$',
		errorMsg: {
			en: 'This field can only be a valid phone number, with extension in "-extension" format.',
			fr: 'Ce champ ne peut contenir qu’un numéro de téléphone valide.',
			trans: gettext('This field can only be a valid phone number.')
		}
	}, {
		type: 'phone10-ext',
		label: gettext('Phone Number: 10 digit (Allow Extension)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[0-9]{3}-[0-9]{3}-[0-9]{4}(-[0-9]{1,10})?$',
		errorMsg: {
			en: 'This field must be a 10 digit phone number with extension in 123-456-7890-extension format.',
			fr: 'Ce champ doit être un numéro de téléphone comprenant 10 caractères numériques et un numéro de poste dont le format est 123-456-7890-poste.',
			trans: gettext('This field must be a 10 digit phone number with extension in 123-456-7890-extension format.')
		}
	}, {
		type: 'uk-phone-number',
		label: gettext('Phone Number: United Kingdom'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^((\\+44)?)([ ]?)(0?)([0-9]{2,5})([ ]?)(([0-9]{3,4})?)([ ]?)([0-9]{4,6})$',
		errorMsg: {
			en: 'Must be in format +44 0xx(2-5 numbers) xxx(optional 3-4 numbers) xxxx(4-6 numbers)',
			fr: 'Ce champ doit être au format 44 0xx (2-5 chiffres) xxx (optionnels numéros 3-4) xxxx (4-6 chiffres)',
			trans: gettext('Must be in format +44 0xx(2-5 numbers) xxx(optional 3-4 numbers) xxxx(4-6 numbers)')
		}
	},{
		type: 'uk-postal-code',
		label: gettext('Post Code (United Kingdom)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([A-Z][A-Z]?)(([0-9][0-9]?)|([0-9][A-Z]))[ ][0-9][A-Z][A-Z]$',
		errorMsg: {
			en: 'Must be in format [L-Letter N-Number]: LN NLL or LNN NLL or LLN NLL or LLNN NLL or LNL NLL or LLNL NLL',
			fr: 'Ce champ doit être au format [L-Lettre N-Nombre]: LN NLL ou LNN NLL NLL ou LLN ou LLNN NLL ou LNL NLL NLL ou LLNL',
			trans: gettext('Must be in format [L-Letter N-Number]: LN NLL or LNN NLL or LLN NLL or LLNN NLL or LNL NLL or LLNL NLL')
		}
	},{
		type: 'postal',
		label: gettext('ZIP/Postal Code (US/Canada)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([0-9]{1,5}|[A-Za-z][0-9][A-Za-z]\ ?[0-9][A-Za-z][0-9])$',
		errorMsg: {
			en: 'This field must be a valid zip code.',
			fr: 'Ce champ doit contenir un code zip valide.',
			trans: gettext('This field must be a valid zip code.')
		}
	}, {
		type: 'postal-ca',
		label: gettext('Postal Code (Canada)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[A-Za-z][0-9][A-Za-z]\ ?[0-9][A-Za-z][0-9]$',
		errorMsg: {
			en: 'This field must be a valid postal code.',
			fr: 'Ce champ doit contenir un code postal valide.',
			trans: gettext('This field must be a valid postal code.')
		}
	},  {
		type: 'postal-three-digit',
		label: gettext('Postal Code (Canada - First Three Digits)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[A-Za-z][0-9][A-Za-z]$',
		errorMsg: {
			en: 'This field must be a valid 3-digit postal code.',
			fr: 'Ce champ doit être valide code postal de 3 chiffres',
			trans: gettext('This field must be a valid 3-digit postal code.')
		}
	},  {
		type: 'uniform-resource-locator',
		label: gettext('URL (web address)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '((https?://)|(HTTPS?://))((([A-Za-z0-9\\-]+)(\\.{1}))+)?([A-Za-z0-9\\-])+(\\.{1})([A-Za-z0-9]{2,63})',
		errorMsg: {
			en: 'This field must be a valid URL',
			fr: 'Ce champ doit être une URL valide',
			trans: gettext('This field must be a valid URL')
		}
	}, {
		type: 'domain-validation',
		label: gettext('Domain (web address with no path)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '((https?://)|(HTTPS?://))?((([A-Za-z0-9\\-]+)(\\.{1}))+)?([A-Za-z0-9\\-])+(\\.{1})([A-Za-z0-9]{2,63})$',
		errorMsg: {
			en: 'This field must be a valid Domain',
			fr: 'Ce champ doit être un nom de demaine valide',
			trans: gettext('This field must be a valid Domain')
		}
	}, {
		type: 'postal-us',
		label: gettext('ZIP Code (US)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([0-9]{5})$|^([0-9]{5}-[0-9]{4})$',
		errorMsg: {
			en: 'This field must be a valid postal code.',
			fr: 'Ce champ doit contenir un code postal valide.',
			trans: gettext('This field must be a valid postal code.')
		}
	}, {
		type: 'currency',
		label: gettext('Currency (Dollar)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		hasDollar: true,
		regex: '(^-?[\\$]?\\d+((,|\\s)?\\d{3})*((\\.|,)[0-9]{1,2})?[\\$]?$)',
		errorMsg: {
			en: 'This field must be a numerical amount in dollars with optional cents.',
			fr: 'Ce champ doit être un montant en dollars pour lequel les cents sont facultatifs.',
			trans: gettext('This field must be a numerical amount in dollars with optional cents.')
		}
	}, {
		type: 'currency-euro',
		label: gettext('Currency (Euro)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		hasEuro: true,
		regex: '(^€?\\d+((,|\\s)?\\d{3})*((,)[0-9]{1,2})?€?$)',
		errorMsg: {
			en: 'This field must be a numerical amount in euro with optional cents.',
			fr: 'Ce champ doit être un montant en euro pour lequel les cents sont facultatifs.',
			trans: gettext('This field must be a numerical amount in euros with optional cents.')
		}
	}, {
		type: 'percentage-bound',
		label: gettext('Percentage (0-100)'),
		showRange: false,
		showPrecision: true,
		showDomain: false,
		hasPercentage: true,
		regex: '^((([0-9][0-9]?)([\.,][0-9]*)?)|100)\\%?$',
		errorMsg: {
			en: 'This field must be a percentage between 0-100.',
			fr: 'Ce champ doit être un pourcentage se situant entre 0 et 100.',
			trans: gettext('This field must be a percentage between 0-100.')
		}
	},{
		type: 'percentage-unbound',
		label: gettext('Percentage (Unbound)'),
		showRange: false,
		showPrecision: true,
		showDomain: false,
		hasPercentage: true,
		regex: '^(\\%)?[0-9]*([\.,][0-9]*)?(\\%)?$',
		errorMsg: {
			en: 'This field can only consist of numbers.',
			fr: 'Ce champ ne peut contenir que des nombres.',
			trans: gettext('This field can only consist of numbers.')
		}
	},{
		type: 'wordCount',
		label: gettext('Word Limits'),
		showRange: false,
		showWordRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^.*$',
		errorMsg: {
			en: 'This value must be between {min} and {max} words.',
			fr: 'Cette valeur doit être comprise entre {min} et {max} môts.',
			trans: gettext('This value must be between {min} and {max} words.')
		}
	},{
		type: 'all',
		label: gettext('All Characters'),
		showRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^.*$',
		errorMsg: {
			en: 'Invalid entry.',
			fr: 'Entrée incorrecte.',
			trans: gettext('Invalid entry.')
		}
	}],

	ssnValidationTypes: [
		{
			type: 'ssn-us',
			label: gettext('Social Security Number (US)'),
			showRange: false,
			showPrecision: false,
			showDomain: false,
			regex: '^([0-9]{3}-?[0-9]{2}-?[0-9]{4})$',
			errorMsg: {
				en: 'This field must be a valid social security number.',
				trans: gettext('This field must be a valid social security number.'),
			},
		}, {
			type: 'ssn-can',
			label: gettext('Social Insurance Number (Canada)'),
			showRange: false,
			showPrecision: false,
			showDomain: false,
			regex: '^([0-9]{3}-?[0-9]{3}-?[0-9]{3})$',
			errorMsg: {
				en: 'This field must be a valid social insurance number.',
				trans: gettext('This field must be a valid social insurance number.'),
			},
		},
	],

	initialize: function($super, field, config) {
		var that = this;

		$super(field, config);

		var currentLang = (window.LOCALE && window.LOCALE.language) || document.documentElement.lang || 'en';
		if (currentLang !== 'en') {
			for (var i = 0; i < this.validationTypes.length; i++) {
				this.validationTypes[i]['errorMsg'][currentLang] = this.validationTypes[i]['errorMsg']['trans'];
			}
		}

		if (!this.value) {
			this.value = {
				errorMsg: {
					en: 'Invalid entry.'
				}
			};
			if (currentLang !== 'en') {
				this.value['errorMsg'][currentLang] = gettext('Invalid entry.');
			}
		}

		this.lengthRange = new Validation.Range({
			field: field,
			value: this.value,
			keys: {min:'minLength', max:'maxLength'}
		});

		this.wordRange = new Validation.Range({
			field: field,
			value: this.value,
			format: gettext('{0} - {1} words'),
			keys: {min:'minWords', max:'maxWords'}
		})

		this.valueRange = new Validation.Range({
			field: field,
			value: this.value,
			label: gettext('Limit Value'),
			format: gettext('Between') + ' {0} - {1}',
			keys: {min:'minValue', max:'maxValue'}
		});

		this.errorMessage = new chide.opts.Text({
			field:this,
			inputClass: "text short",
			label: gettext('Current Count'),
			help: gettext('Error Message - In order to override default error messages for min/max validation, include {min} and {max} in your error message.'),
			value: this.value.errorMsg,
			changed: function(value) {
				this.field.value.errorMsg = this.value;
			}
		});

		this.precision = new chide.opts.Number({
			field:this,
			label: gettext('Precision'),
			value: this.value.precision || 3,
			min: 0,
			max: 100,
			type: 'int',
			changed:function(value){
				that.value.precision = value;
			}
		});
	},

	getValidationTypes: function(type) {
		/* this is to allow questions currently using ssn/sin validation to continue using it */
		let validationTypes = this.validationTypes;
		if (['ssn-can', 'ssn-us'].indexOf(type) >= 0) {
			validationTypes = validationTypes.concat(this.ssnValidationTypes);
		}
		return validationTypes;
	},

	getType: function (type){
		let validationTypes = this.getValidationTypes(type);
		for (var i = 0; i < validationTypes.length; i++){
			if (validationTypes[i].type == type){
				return $.cloneObj(validationTypes[i]);
			}
		}
		return {};
	},

	render: function($super) {
		var that = this;

		var lengthRangeDisplay = this.lengthRange.render();
		var valueRangeDisplay = this.valueRange.render();
		var precisionDisplay = this.precision.render();
		var wordRangeDisplay = this.wordRange.render();

		var errorMsg = this.errorMessage.render();

		var validationSelect = $('<select class="custom-select custom-select-sm"><option value="none">' +
			gettext('None') + '<\/option><\/select>').css('width', '145px');

		var validationDetails = $('<div><\/div>')
			.append(lengthRangeDisplay)
			.append(valueRangeDisplay)
			.append(precisionDisplay)
			.append(errorMsg)
			.append(wordRangeDisplay);

		_.each(this.getValidationTypes(this.value.type), function(el) {
			validationSelect
				.append($.format('<option value="{0}">{1}<\/option>', [el.type, el.label]));
		});

		if (this.getType(this.value.type).showRange){
			lengthRangeDisplay.show();
		}
		else {
			lengthRangeDisplay.hide();
		}

		if (this.getType(this.value.type).showWordRange) {
			wordRangeDisplay.show();
		} else {
			wordRangeDisplay.hide();
		}

		if (this.getType(this.value.type).showValueRange) {
			valueRangeDisplay.show();
		}
		else {
			valueRangeDisplay.hide();
		}

		if (this.getType(this.value.type).showPrecision) {
			precisionDisplay.show();
		}
		else {
			precisionDisplay.hide();
		}

		validationSelect
			.val((this.value && this.value.type) ? this.value.type : '')
			.change(function(e) {
				if (that.field.prefix){
					that.field.prefix.empty();
				}
				if (that.field.suffix){
					that.field.suffix.empty();
				}

				that.value.type = $(this).val();

				that.errorMessage.set(that.value.errorMsg = that.getType(this.value).errorMsg);

				if ($(this).val() == 'none') {
					validationDetails.fadeOut();
					errorMsg.fadeOut();
					that.value = {type: 'none'};
				} else {
					validationDetails.fadeIn();
					errorMsg.fadeIn();

					var entry = that.getType(this.value);

					if (entry.showRange) {
						var inputs = $(lengthRangeDisplay).find('input');
						that.value['minLength']	= inputs[0].value;
						that.value['maxLength'] = inputs[1].value;
						lengthRangeDisplay.show();
					}
					else {
						lengthRangeDisplay.hide();
						delete that.value['minLength'];
						delete that.value['maxLength'];
					}

					if (entry.showValueRange) {
						valueRangeDisplay.show();
					}
					else {
						valueRangeDisplay.hide();
						delete that.value['minValue'];
						delete that.value['maxValue'];
					}

					if (entry.showWordRange) {
						wordRangeDisplay.show();
					} else {
						wordRangeDisplay.hide();
					}

					if (entry.showPrecision) {
						precisionDisplay.show();
						that.value.precision = that.precision.value;

					}
					else {
						precisionDisplay.hide();
						delete that.value.precision;
					}

					that.value.regex = entry.regex;
					that.value.errorMsg = entry.errorMsg;
					that.errorMessage.set(entry.errorMsg);

					if (entry.hasDollar && that.field.prefix){
						that.field.prefix.text(' $ ');
					}
					if (entry.hasEuro && that.field.prefix){
						that.field.prefix.text(' € ');
					}
					if (entry.hasPercentage && that.field.suffix){
						that.field.suffix.text(' % ');
					}
				}

			});

		validationDetails.css('margin-top', '0');

		if (!this.value || !this.value.type || this.value.type  == "none"){
			validationDetails.css('display', 'none');
			errorMsg.css('display', 'none');
		}


		if (this.getType(this.value.type).hasDollar && this.field.prefix){
			this.field.prefix.text(' $ ');
		}
		if (this.getType(this.value.type).hasEuro && this.field.prefix){
			this.field.prefix.text(' € ');
		}
		if (this.getType(this.value.type).hasPercentage && this.field.suffix){
			this.field.suffix.text(' % ');
		}

		var result = $super()
			.addClass('validation col-sm-12');

		if (this.displayInline){
			result.append("<strong class='inline'>" + this.label + "</strong>");
			validationSelect.css('margin-bottom', '0');
		}

		result.append(validationSelect);
		result.append(validationDetails);
		return result;
	},

	get: function() {
		return $.extend({}, this.value, {
			minLength: this.lengthRange.value[0],
			maxLength: this.lengthRange.value[1]
		});
	}
});

Validation.Range = Class.create(chide.opts.Value, {
	label: gettext('Limit length:'),
	format: gettext("{0} - {1} characters"),
	config: {type: 'int', inputClass: 'text number', size: 1},
	keys: {min: 0, max: 1},
	render: function($super) {
		var that = this;
		this.minLength = new chide.opts.Number($.extend({}, this.config, { field:this,
			value: that.value[that.keys.min] || undefined,
			max: parseInt(that.value[that.keys.max]) || null,
			changed: function(val){
				that.maxLength.min = val;
				that.value[that.keys.min] = val;
			}
		}));
		this.maxLength = new chide.opts.Number($.extend({}, this.config, { field:this,
			value: that.value[that.keys.max] || undefined,
			min: parseInt(that.value[that.keys.min]) || null,
			changed: function(val){
				that.value[that.keys.max] = val;
				that.minLength.max = val;
			}
		}));
		var minEl = this.minLength.render().find('input');
		var maxEl = this.maxLength.render().find('input');
		var rendered = $super().append(
			this.format.replace('{0}', '<span class="min"></span> ').replace('{1}', ' <span class="max"></span>'))
				.find('span.min').replaceWith(minEl).end()
				.find('span.max').replaceWith(maxEl).end();
		return rendered;
	}
});

Validation.Restriction = Class.create(chide.opts.Checkbox, {
	label: gettext('Restrict number of selected choices'),
	help: gettext('Restrict number of selected choices - Check this option if you would like to specify the range of choices that must be selected for this question.'),

	options: {
		range: Class.create(Validation.Range, {
			label: '',
			format: gettext('{0} and {1} choices'),
			optionClass: 'opt inline'
		}),

		errorMsg: Class.create(chide.opts.Text, {
			label: gettext('Error message:'),
			inputClass: 'text short',
			initialValue: gettext('Invalid entry.')
		})
	},

	initialize: function($super, config) {
		$super(config);

		var range = this.value ? this.value : [undefined, undefined];

		this.value = !!this.value;

		this.range = new this.options.range({ value: range });
		this.errorMsg = new this.options.errorMsg({ value: config.errorMsg || undefined });
	},

	render: function($super) {
		var that = this;

		var range = $('<span></span>').append(this.range.render().unwrap());
		var errorMsg = this.errorMsg.render();

		var subs = range.add(errorMsg);

		var rendered = $super()
			.append(range, errorMsg)
			.bind('changed', function(e, value) {
				$('span.label', rendered).text(value ? gettext('Restrict to between') : that.label);
				if (value){$('a.help', rendered).hide();} else {$('a.help', rendered).show();}
				subs.toggle(value);
			});
		this.set(this.value);

		return rendered;
	},

	serialize: function() {
		return this.value ? $.extend({}, {
			minChecked: this.range.value[0],
			maxChecked: this.range.value[1]
		}) : undefined;
	}
});

module.exports = Validation;
